import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axios } from 'lib/axios';
import { listParams, qnaKey } from './queryKeys';

const getUnanswered = (resource, id, paging) =>
  axios.get(`/api/${resource}/${id}/qna/questions/unanswered`, { params: listParams(paging) });

export const useUnanswered = (resource, id, paging, options = {}) =>
  useQuery({
    queryKey: qnaKey(resource, id, 'unanswered', paging.page, paging.pageSize, paging.order),
    queryFn: () => getUnanswered(resource, id, paging),
    select: ({ data }) => ({ items: data.data, total: data.total }),
    placeholderData: keepPreviousData,
    ...options,
  });
